// Generated by scripts/observability/appRoutePatterns.ts from the app/ tree. Do not edit.
// Regenerate: bun scripts/observability/appRoutePatterns.ts
export const APP_ROUTE_PATTERNS: readonly string[] = [
  "/",
  "/account-deleted",
  "/api/.well-known/microsoft-identity-association",
  "/api/account/passkeys",
  "/api/account/passkeys/options",
  "/api/account/security-activity",
  "/api/account/sign-in-approvals/decide",
  "/api/account/sign-in-approvals/inspect",
  "/api/action-approvals",
  "/api/admin/compliance-mode",
  "/api/admin/revoke-user-sessions",
  "/api/artifacts",
  "/api/assets",
  "/api/auth/workos",
  "/api/auth/workos/authorize",
  "/api/auth/workos/callback",
  "/api/auth/workos/desktop-exchange",
  "/api/auth/workos/refresh",
  "/api/auth/workos/session-handoff",
  "/api/auth/workos/sign-in/hosted",
  "/api/auth/workos/sign-in/passkey/options",
  "/api/auth/workos/sign-in/passkey/verify",
  "/api/auth/workos/sign-in/phone/poll",
  "/api/auth/workos/sign-in/phone/start",
  "/api/auth/workos/sign-in/send-code",
  "/api/auth/workos/sign-in/verify-code",
  "/api/auth/workos/sign-in/verify-totp",
  "/api/auth/workos/signout",
  "/api/auth/workos/signout-all",
  "/api/auth/workos/webhook",
  "/api/aws",
  "/api/browserAgent",
  "/api/calendar/commitments",
  "/api/calendar/diagnostics",
  "/api/calendar/duplicate-suggestion",
  "/api/calendar/events",
  "/api/calendar/invite/:token",
  "/api/calendar/item",
  "/api/calendar/overload-suggestion",
  "/api/calendar/reply/:token",
  "/api/calendar/source",
  "/api/calendar/suggestions",
  "/api/calendar/todos",
  "/api/cesium-assets/:...path",
  "/api/checkVendorToken",
  "/api/checkout",
  "/api/checkout/session",
  "/api/claude-code",
  "/api/cleanupSync",
  "/api/clock",
  "/api/codex-tunnel",
  "/api/codex-tunnel/helper",
  "/api/connect/access",
  "/api/contacts",
  "/api/convert",
  "/api/customWorkflows",
  "/api/desktop-updates/:...path",
  "/api/dev/frontend-logs",
  "/api/device-files/devices",
  "/api/device-files/helper",
  "/api/device-files/helper/requests",
  "/api/device-files/helper/upload",
  "/api/device-files/helper/write-back",
  "/api/device-files/hydrate",
  "/api/device-files/ingest",
  "/api/device-files/write-back",
  "/api/device-health",
  "/api/document-artifact",
  "/api/document-artifact/file",
  "/api/document-editor",
  "/api/document-history",
  "/api/document-image-urls",
  "/api/documents/embeddings",
  "/api/documents/team-access",
  "/api/download",
  "/api/emailSenders",
  "/api/everyday/directions",
  "/api/everyday/money",
  "/api/everyday/receipts",
  "/api/everyday/stocks",
  "/api/everyday/trips",
  "/api/feedback-tickets",
  "/api/feedback-tickets/board",
  "/api/feedback-tickets/manage",
  "/api/feedback-tickets/task-status",
  "/api/feedback-tickets/trigger",
  "/api/getAccessToken",
  "/api/getAnswerAndScore",
  "/api/getJobStatus",
  "/api/getNotifications",
  "/api/getTTSAudio",
  "/api/getTempKey",
  "/api/getVendorData",
  "/api/gptAnswer",
  "/api/gptAnswer/cancel",
  "/api/gptAnswer/orchestrate",
  "/api/gptAnswer/voice-turn",
  "/api/gptStreaming",
  "/api/gptSummary",
  "/api/gptUtilities",
  "/api/growth-operator",
  "/api/health",
  "/api/icloud-helper/cloud-document-content",
  "/api/icloud-helper/messages",
  "/api/icloud-helper/messages/send",
  "/api/icloud-helper/status",
  "/api/icloud-helper/sync",
  "/api/initSyncList",
  "/api/integrations/cloud-documents/credential",
  "/api/integrations/cloud-documents/owner-setup",
  "/api/integrations/connection-readiness",
  "/api/integrations/crm/api-key",
  "/api/integrations/entertainment",
  "/api/integrations/home-control/authorize",
  "/api/integrations/home-control/setup",
  "/api/integrations/meeting-catalog/execute",
  "/api/integrations/meeting-catalog/owner-review",
  "/api/integrations/meeting-catalog/webhooks/:handle",
  "/api/integrations/music/catalog",
  "/api/integrations/music/musickit",
  "/api/integrations/music/oauth/callback",
  "/api/integrations/music/oauth/exchange",
  "/api/integrations/music/oauth/start",
  "/api/integrations/music/operation",
  "/api/integrations/provider-record",
  "/api/integrations/provider-record/account",
  "/api/integrations/provider-record/account-identity",
  "/api/integrations/provider-record/assisted-setup",
  "/api/integrations/provider-record/batch",
  "/api/integrations/provider-record/catalog",
  "/api/integrations/provider-record/oauth",
  "/api/integrations/provider-record/plaid",
  "/api/integrations/provider-record/secondary-credential",
  "/api/integrations/provider-record/source",
  "/api/integrations/provider-record/status",
  "/api/integrations/review-request",
  "/api/internal/security-audit/refusal",
  "/api/internal/wopi",
  "/api/jobs/completion-close",
  "/api/jobs/completion-delivery",
  "/api/jobs/completion-undo",
  "/api/jobs/completion-undo-finalization",
  "/api/jobs/completion-undo-recovery",
  "/api/jobs/completions",
  "/api/jobs/run",
  "/api/jobs/schedules",
  "/api/kitchen",
  "/api/legal/consent",
  "/api/linkedin/messages/import",
  "/api/local-mail-helper",
  "/api/mailboxAddress",
  "/api/mailboxMessages",
  "/api/makeCalendarQuery",
  "/api/mandates",
  "/api/mandates/:kind",
  "/api/map-tiles/osm/:z/:x/:y",
  "/api/media/keep-image",
  "/api/media/podcasts",
  "/api/meetings/prepare",
  "/api/meetings/review",
  "/api/memory",
  "/api/memory/field",
  "/api/messages",
  "/api/messages/unread-summary",
  "/api/mobile-config",
  "/api/mobile-device-sync",
  "/api/mobile/push-registration",
  "/api/news-image",
  "/api/news-research",
  "/api/notes",
  "/api/notifications/contacts",
  "/api/notifications/feed",
  "/api/notifications/follow-up",
  "/api/notifications/reminder",
  "/api/notifications/resolve",
  "/api/oauth/native/complete",
  "/api/oauth/state",
  "/api/observability/client",
  "/api/onboarding/answers",
  "/api/onboarding/progress",
  "/api/oneDrivePicker",
  "/api/online-accounts",
  "/api/paired-native-helper",
  "/api/people",
  "/api/phone/caller-id",
  "/api/phone/calls",
  "/api/phone/calls/history",
  "/api/phone/calls/observe",
  "/api/phone/calls/todos",
  "/api/phone/events",
  "/api/phone/token",
  "/api/photos",
  "/api/photos/link-face",
  "/api/photos/people",
  "/api/photos/phone/finalize",
  "/api/photos/phone/presign",
  "/api/photos/phone/removed",
  "/api/photos/phone/status",
  "/api/photos/search",
  "/api/photos/suggest-matches",
  "/api/places/search",
  "/api/platform",
  "/api/platform-communications",
  "/api/platform-integrations/entertainment",
  "/api/platform-integrations/entertainment/youtube-player-canary",
  "/api/platform-integrations/review",
  "/api/platform/commons/contributor-consent",
  "/api/platform/commons/organization-consent",
  "/api/platform/commons/organization-relationship",
  "/api/platform/commons/signals",
  "/api/platform/document",
  "/api/platform/playbook-feedback",
  "/api/preferences/theme",
  "/api/preferences/timezone",
  "/api/presignedurl",
  "/api/privacy/consent",
  "/api/privacy/conversations",
  "/api/privacy/export",
  "/api/privacy/imported-data",
  "/api/privacy/settings",
  "/api/processJob",
  "/api/provider-change-events/:provider/:routeToken",
  "/api/proxy-image",
  "/api/public/contact",
  "/api/public/unsubscribe",
  "/api/publicDocs",
  "/api/pyro/explore",
  "/api/pyro/external-research",
  "/api/records",
  "/api/remote-image",
  "/api/runGraphQuery",
  "/api/scan/analyze",
  "/api/scan/calendar-draft",
  "/api/scan/calendar-fit",
  "/api/scan/destination",
  "/api/scan/flight",
  "/api/scan/receipt",
  "/api/scan/report",
  "/api/scan/save-contact",
  "/api/scribe-token",
  "/api/scribe-usage",
  "/api/script/clusterInterests",
  "/api/script/fetchCloudConvertOperations",
  "/api/security/csp-report",
  "/api/security/link-check",
  "/api/security/url-grant",
  "/api/self-healing",
  "/api/sendEmail",
  "/api/shareFiles",
  "/api/silo-access/agents",
  "/api/silo-access/agents/:linkId/cancel",
  "/api/silo-access/approvals",
  "/api/silo-access/approvals/:id/approve",
  "/api/silo-access/approvals/:id/deny",
  "/api/silo-access/device-session",
  "/api/silo-access/devices",
  "/api/silo-access/devices/:id/revoke",
  "/api/silo-access/devices/register",
  "/api/silo-access/events",
  "/api/silo-access/status",
  "/api/silo-access/unseal",
  "/api/silo-access/unseal/challenge",
  "/api/silo-recovery/cancel",
  "/api/social-media",
  "/api/social-media/engagement",
  "/api/speechToText",
  "/api/sports",
  "/api/startProviderSync",
  "/api/storeConversation",
  "/api/storeGeneratedDocumentArtifact",
  "/api/stripe/portal",
  "/api/stripe/storage",
  "/api/stripe/top-up",
  "/api/stripe/webhook",
  "/api/submitComponent",
  "/api/survey",
  "/api/syncDriveFiles",
  "/api/syncProgress",
  "/api/team-messaging/owner",
  "/api/team-messaging/webhook",
  "/api/team/invite",
  "/api/team/invite/send",
  "/api/team/invite/validate",
  "/api/team/members",
  "/api/theme/artwork-light",
  "/api/timezones",
  "/api/transferFiles",
  "/api/upload",
  "/api/vault-agent/connector",
  "/api/vault-agent/enroll",
  "/api/vault-agent/session",
  "/api/vault-mcp",
  "/api/verifyPurchase",
  "/api/video-call/brief",
  "/api/video-call/guest",
  "/api/video-call/lifecycle",
  "/api/video-call/live-assist",
  "/api/video-call/presence",
  "/api/video-call/token",
  "/api/video-call/transcription",
  "/api/video-call/webhook",
  "/api/voices",
  "/api/webhooks/microsoft/contacts",
  "/api/webhooks/ses",
  "/api/wellbeing",
  "/api/whatsapp-helper/consent",
  "/api/whatsapp-helper/messages",
  "/api/whatsapp-helper/queue",
  "/api/whatsapp-helper/status",
  "/api/workspace/persistence",
  "/api/workspace/recovery",
  "/api/workspace/scene",
  "/api/workspace/scenes",
  "/auth/callback",
  "/auth/desktop-callback",
  "/call/:callId",
  "/changelog",
  "/connect",
  "/cookies",
  "/dashboard",
  "/desktop",
  "/disaster-recovery",
  "/help",
  "/help/:slug",
  "/help/youtube-data",
  "/helper/connect",
  "/invite",
  "/landing-variant/:locale/:device",
  "/legal-updates",
  "/manifest.webmanifest",
  "/privacy-policy",
  "/robots.txt",
  "/security",
  "/sign-in",
  "/sign-in/app",
  "/silo-recovery/cancel",
  "/sitemap.xml",
  "/status",
  "/subprocessors",
  "/success/:vendor",
  "/terms",
  "/watch",
];
